<div class="">

    <div class="row align-items-center" style="margin-bottom: 24px;margin-left: 24px">
        <div class="col-lg-4 col-md-6 col-sm-12 d-flex align-items-center" style="gap: 10px;flex-wrap: nowrap;">    <!-- 🔍 Search input -->
            <div class="input-group form-password-toggle d-flex" style="max-width: 250px; min-width: 150px;">
                <input type="text" class="form-control search-bar" placeholder="Recherche par mot clé"
                >
                <div class="input-group-append">
        <span class="input-group-text" id="basic-addon-search1" style="color: black; cursor: pointer; background-color: transparent; border-left: none; padding: 0 10px;">
          <i data-feather="search" [size]="20"></i>
        </span>
                </div>

            </div>

            <!-- Filter toggle button -->
            <button class="btn btn-outline-primary btn-icon" (click)="toggleFilter()">
                <i data-feather="filter"></i>
            </button>
            <span class="filter-summary" *ngIf="filterSummary" [title]="filterSummary">{{ filterSummary }}</span>

        </div>
        <!-- 📌 Filter sidebar -->

    </div>

    <hr>

    <div class="table-responsive">
        <table class="table table-hover">
            <thead class="align-middle custom-thead">
            <tr>
                <th>NUMÉRO DE SÉRIE</th>
                <th>ENTREPOT</th>
                <th>ÉTAT</th>
                <th>DOCUMENT DE VENTE</th>
                <th>ÉTAT</th>

            </tr>
            </thead>
            <tbody>
            <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>

                </td>
            </tr>
            </tbody>
        </table>
    </div>

</div>
